import { render } from "./afis_criminal_check.html?vue&type=template&id=9d29f31e&external"
import script from "./afis_criminal_check.js?vue&type=script&lang=js&external"
export * from "./afis_criminal_check.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__